import React from "react";

import styled from "@mui/material/styles/styled";
import Typography, { TypographyProps } from "@mui/material/Typography";

export interface BadgeProps extends TypographyProps {
  disabled?: boolean;
}

type BadgePropsWithoutChildren = Omit<BadgeProps, "children">;

const Badge = styled<React.FC<BadgeProps>>(({ disabled: _, ...props }) => (
  <Typography {...props} />
))(({ theme, disabled }) => ({
  ...theme.typography.labelMed,
  fontWeight: 600,
  color: "#FFF",
  backgroundColor: disabled
    ? theme.palette.shades.neutral[100]
    : theme.palette.shades.primary[600],
  borderRadius: "8px",
  padding: "2px 4px",
  textTransform: "uppercase",
}));

export const DefaultBadge = (props: BadgePropsWithoutChildren) => (
  <Badge {...props}>Default</Badge>
);

export const RecommendedBadge = (props: BadgePropsWithoutChildren) => (
  <Badge {...props}>Recommended</Badge>
);

export default Badge;
